const playerConfig = {
  START_TIME: 0,
  MIN_VIDEO_TIME: 0,
  DEFAULT_VOLUME: 0,
  MAX_VOLUME: 1,
  VOLUME_STEP: 0.1,
  SEEK_STEP: 5,
  DEFAULT_PLAYBACK_RATE: 1.0,
  PLAYBACK_STEP: 0.25,
  PLAYBACK_UPPER_LIMIT: 2.0,
  PLAYBACK_LOWER_LIMIT: 0.75,
};

export default playerConfig;
